import { render, staticRenderFns } from "./AddMoney.vue?vue&type=template&id=6c3d5270&"
import script from "./AddMoney.vue?vue&type=script&lang=js&"
export * from "./AddMoney.vue?vue&type=script&lang=js&"
import style0 from "./AddMoney.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports